<template>
  <div>
    <Teleport to="body">
      <ParseResumeModalContent open class="z-max"/>
    </Teleport>
  </div>
</template>

<script setup>
import ParseResumeModalContent from "./ParseResumeModalContent.vue";
import {onBeforeMount, onBeforeUnmount, watch} from "vue";
import {useParseResumeStore} from "../stores/ParseResumeStore.js";
import {useCandidateApplicationFormStore} from "../stores/CandidateApplicationFormStore.js";
import {mapParsedResumeToCandidateApplicationFormStore} from "../helpers/MapParsedResumeToDifferentStore.js";
import {useCandidateProfileStore} from "../stores/CandidateProfileStore.js";

const emits = defineEmits(["nextStep", "prevStep", "update:validating", "update:validator", "newResume"]);

const store = useParseResumeStore();
const applicationStore = useCandidateApplicationFormStore();
const candidateProfileStore = useCandidateProfileStore();

watch(() => store.resume.error, (err) => {
  if (!err) return;
  emits("update:validator", () => true);
  emits("update:validating", false);
  toast.warning("Uh oh, our resume auto-complete just went offline!");
  toast.info("Don't worry, you can still apply - we just skipped that step 🎉");
  emits("nextStep");
});

onBeforeMount(() => {
  emits("update:validating", true);
  emits("update:validator", () => false);

  applicationStore.setFurthestStep(4, "Business Draft GPT complete profile");

  store.addCompletionCallback(() => {
    mapParsedResumeToCandidateApplicationFormStore(store.candidate, store, applicationStore, candidateProfileStore, true);
    applicationStore.usedResumeParser = true;
    applicationStore.setShowCandidateCompleteProfile();
    emits("update:validator", () => true);
    emits("update:validating", false);
    emits("nextStep");
  });

  store.addResetCallback(() => {
    toast.success("We've moved you back to the resume selector - your information is still saved.");
    emits("newResume");
    return true;
  });

  store.parseResume(false);
});

onBeforeUnmount(() => {
  store.flushCompletionCallbacks();
});
</script>
